const _require = require('lodash'),
  difference = _require.difference;
const _require2 = require('../lib/evaluateSource'),
  evaluateSource = _require2.evaluateSource;
const emcoDeleteValidPipesBehavior = async (source, content, parentContentPath, transientContext, nativeFunctions, sourceEvaluator) => {
  var _Object$keys;
  const _transientContext$sel = transientContext.selection,
    selection = _transientContext$sel === void 0 ? {} : _transientContext$sel;
  const _selection$pipe = selection.pipe,
    selectedPipesIds = _selection$pipe === void 0 ? [] : _selection$pipe;
  const pipesToKeep = new Set();
  for (let i = 0; i < selectedPipesIds.length; i += 1) {
    const querySource = {
      type: 'queryEntityBehavior',
      entityName: 'Form',
      properties: ['id', 'v_title', 'content', 'v_weldDownstreamPipe', 'v_weldUpstreamPipe'],
      equalsNoneOf: {
        v_formTypeName: ['Audit Trail', 'Pipe']
      },
      contains: {
        content: selectedPipesIds[i]
      }
    };

    /* eslint-disable-next-line no-await-in-loop */
    const allForms = await evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);

    // If the Pipe was selected, it means at least one Form will be found.
    if ((allForms === null || allForms === void 0 ? void 0 : allForms.length) > 0) pipesToKeep.add(selectedPipesIds[i]);
  }
  const pipesToDelete = difference(selectedPipesIds, Array.from(pipesToKeep));
  await evaluateSource({
    type: 'bulkDeleteFormsBehavior',
    values: pipesToDelete
  }, content, parentContentPath, transientContext, nativeFunctions);
  const pipesDeleted = (_Object$keys = Object.keys(pipesToDelete)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length;
  const pipesDeletedString = pipesDeleted === 1 ? '1 Pipe was' : "".concat(pipesDeleted, " Pipes were");
  const pipesKept = pipesToKeep.size;
  const pipesKeptString = pipesKept === 1 ? '1 Pipe was' : "".concat(pipesKept, " Pipes were");
  await sourceEvaluator({
    type: 'alertBehavior',
    message: "".concat(pipesDeletedString, " deleted. ").concat(pipesKeptString, " not deleted."),
    options: [{
      title: 'OK'
    }]
  });
};
module.exports = {
  evaluate: emcoDeleteValidPipesBehavior
};